import cacheKeys from '@/data/api/cacheKeys';
import { getOrderDetailEvents } from '@/data/api/request/orderDetailsRequest';
import { useQuery } from '@tanstack/react-query';

export function useGetOrderDetailEvents(orderId: string) {
  const { data, error, isLoading } = useQuery({
    queryKey: [cacheKeys.detailOrder.events],
    queryFn: () => getOrderDetailEvents(orderId),
    enabled: !!orderId,
  });

  return {
    data,
    error,
    isLoading,
  };
}
